var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.1 188.1",
    style: {
      enableBackground: "new 0 0 188.1 188.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.4,46.1h-1.1c0,0-0.1,0-0.1,0h-36.6c-0.1,0-0.1,0-0.2,0c-0.8-4.4-4.7-7.8-9.4-7.8 c-4.7,0-8.6,3.4-9.4,7.8c-0.1,0-0.1,0-0.2,0H47.9c0,0-0.1,0-0.1,0h-1.1l-0.5,1.1L26.9,94.1h-2c0,12.7,10.3,23.1,23.1,23.1 c12.7,0,23.1-10.3,23.1-23.1h-2L50.6,49.7h33.9c0.1,0,0.1,0,0.2,0c0.7,3.9,3.8,6.9,7.6,7.6c0,0.1,0,0.1,0,0.2v81H47.9 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h92.3c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H95.8v-81c0-0.1,0-0.1,0-0.2 c3.9-0.7,6.9-3.8,7.6-7.6c0.1,0,0.1,0,0.2,0h33.9l-18.4,44.4h-2c0,12.7,10.3,23.1,23.1,23.1c12.7,0,23.1-10.3,23.1-23.1h-2 L141.4,46.1z M47.9,113.6c-9.6,0-17.5-6.9-19.2-16h38.4C65.4,106.7,57.5,113.6,47.9,113.6z M64.4,92.3H31.4l16.5-39.7L64.4,92.3z  M94.1,53.9c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C100.1,51.2,97.4,53.9,94.1,53.9z M140.2,52.5l16.5,39.7h-32.9 L140.2,52.5z M140.2,113.6c-9.6,0-17.5-6.9-19.2-16h38.4C157.7,106.7,149.8,113.6,140.2,113.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.3,148H28.8c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8h130.5c1,0,1.8-0.8,1.8-1.8 C161.1,148.8,160.3,148,159.3,148z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158,0H30.1C13.5,0,0,13.5,0,30.1V158c0,16.6,13.5,30.1,30.1,30.1H158c16.6,0,30.1-13.5,30.1-30.1V30.1 C188.1,13.5,174.6,0,158,0z M184.6,158c0,14.7-11.9,26.6-26.6,26.6H30.1c-14.7,0-26.6-11.9-26.6-26.6V30.1 c0-14.7,11.9-26.6,26.6-26.6H158c14.7,0,26.6,11.9,26.6,26.6V158z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/balance-icon.ffbe625cfadb63175b9e58291853cfe1.svg";
export { ForwardRef as ReactComponent };